const Radio = {
  baseStyle: {
    control: {
      _checked: {
        bgColor: "main",
        borderColor: "main",
        color: "white",
        _before: {
          content: "''",
          display: "inline-block",
          pos: "relative",
          w: "50%",
          h: "50%",
          borderRadius: "50%",
          bgColor: "white",
        },
        _hover: {
          bgColor: "main",
          borderColor: "main",
        },
      },
    },
  },
};

export default Radio;
